var map = {
	"./1000+.png": 162,
	"./404.png": 163,
	"./BookReader.png": 164,
	"./Booknet.png": 165,
	"./BravoFiction.png": 166,
	"./CamelNovel.png": 167,
	"./Chapters.png": 168,
	"./CoralReader.png": 169,
	"./CornReading.png": 170,
	"./DailyBooks.png": 171,
	"./DeerFiction.png": 172,
	"./DolphinReader.png": 173,
	"./Dreams.png": 174,
	"./FICTLF.png": 175,
	"./FancyNovel.png": 176,
	"./FicFun.png": 177,
	"./FicWorld.png": 178,
	"./FictionFlow.png": 179,
	"./FoxFics.png": 180,
	"./FoxFm.png": 181,
	"./Free2Read.png": 182,
	"./FreeRead.png": 183,
	"./FunFic.png": 184,
	"./FunNovel.png": 185,
	"./FunStory-android.png": 186,
	"./Gonovel.png": 187,
	"./GoodFiction.png": 188,
	"./GoodStory.png": 189,
	"./GoodToon.png": 190,
	"./GrapeNovel.png": 191,
	"./HeyRead.png": 192,
	"./HippoNovel.png": 193,
	"./HitNovel.png": 194,
	"./Hitfic.png": 195,
	"./HotNovel.png": 196,
	"./IHear.png": 197,
	"./Inkspired.png": 198,
	"./Inkwell.png": 199,
	"./KiWiReader.png": 200,
	"./Kiwi.png": 201,
	"./LemonRead.png": 202,
	"./LetsRead.png": 203,
	"./Libfic.png": 204,
	"./Liby-android.png": 205,
	"./Liby.png": 206,
	"./LionFiction.png": 207,
	"./Listenow.png": 208,
	"./LoveNovel.png": 209,
	"./LoveRead.png": 210,
	"./Mango.png": 211,
	"./MangoReader.png": 212,
	"./Mebooks.png": 213,
	"./Mobooks.png": 214,
	"./Monkey.png": 215,
	"./MyNovel.png": 216,
	"./Mylib.png": 217,
	"./NovelFox.png": 218,
	"./NovelHut.png": 219,
	"./NovelNow.png": 220,
	"./NovelPro.png": 221,
	"./NovelWorld.png": 222,
	"./NovelZone.png": 223,
	"./Octopus.png": 224,
	"./OrangeReader.png": 225,
	"./OwlReader.png": 226,
	"./PocketFic.png": 227,
	"./PocketeBooks.png": 228,
	"./PocketeReader.png": 229,
	"./Pocketoons.png": 230,
	"./Podfic.png": 231,
	"./PopFic.png": 232,
	"./PopNovel.png": 233,
	"./PopStories.png": 234,
	"./Pumpkin.png": 235,
	"./Rabbit.png": 236,
	"./Read4Fun-ios.png": 237,
	"./Read4Fun.png": 238,
	"./ReadNow.png": 239,
	"./Readify.png": 240,
	"./Readme.png": 241,
	"./Seagull.png": 242,
	"./Sealread.png": 243,
	"./SharkNovels.png": 244,
	"./Shepherd.png": 245,
	"./SnailReads.png": 246,
	"./StarfishFiction.png": 247,
	"./StoryHouse.png": 248,
	"./StoryRover.png": 249,
	"./StorySphere.png": 250,
	"./StorySpot.png": 251,
	"./SuperFiction.png": 252,
	"./SuperNovel.png": 253,
	"./Sweet.png": 254,
	"./TaleTrek.png": 255,
	"./TapRead.png": 256,
	"./Tellstory.png": 257,
	"./TigerReader.png": 258,
	"./Tomato.png": 259,
	"./TopFic.png": 260,
	"./Topicks-android.png": 261,
	"./Topicks.png": 262,
	"./UniFic.png": 263,
	"./VampireNovels.png": 264,
	"./WeJoy.png": 265,
	"./WeRead.png": 266,
	"./Webfiction.png": 267,
	"./Webfm.png": 268,
	"./Webnovel.png": 269,
	"./Webstories.png": 270,
	"./Whatstory.png": 271,
	"./about_bg.png": 272,
	"./android-FicFun.png": 273,
	"./appStore-check.png": 274,
	"./appStore.png": 56,
	"./app_logo.png": 120,
	"./application.png": 275,
	"./banner.png": 276,
	"./banner1.png": 277,
	"./banner2.png": 278,
	"./banner3.png": 279,
	"./basic.png": 280,
	"./bg-game.png": 281,
	"./bg.png": 282,
	"./book.png": 283,
	"./bottom-icon.png": 284,
	"./cherryfiction.png": 285,
	"./close.png": 286,
	"./contact_bg.png": 287,
	"./crazyapp.png": 288,
	"./desc.png": 289,
	"./down (1).png": 290,
	"./down.png": 291,
	"./e1.png": 292,
	"./e2.png": 293,
	"./e3.png": 294,
	"./eAudioBooks.png": 295,
	"./eReader-logo.png": 296,
	"./ereader.png": 297,
	"./fancyNovel-android.png": 298,
	"./ficfun-logo.png": 299,
	"./fj.png": 300,
	"./form_bg.png": 301,
	"./funtel-logo.png": 302,
	"./funtel.png": 303,
	"./goodfic.png": 304,
	"./goodficapp.png": 305,
	"./googlePlay-check.png": 306,
	"./googlePlay.png": 57,
	"./greatnovel.png": 307,
	"./i1.png": 308,
	"./i2.png": 309,
	"./i3.png": 310,
	"./iAudios.png": 311,
	"./iComics.png": 312,
	"./iFiction.png": 313,
	"./iNovel-ios.png": 314,
	"./iNovel.png": 315,
	"./iRomance.png": 316,
	"./iToons.png": 317,
	"./icon.png": 318,
	"./infinitytale.png": 319,
	"./iosGoodStory.png": 320,
	"./iosgoodfiction.png": 321,
	"./left.png": 322,
	"./litchifiction.png": 323,
	"./logo.png": 324,
	"./logo2.png": 325,
	"./logo3.png": 326,
	"./logo4.png": 327,
	"./logo5.png": 328,
	"./m-tel.png": 329,
	"./more.png": 330,
	"./pandareads.png": 331,
	"./peanutnovel.png": 332,
	"./phone.png": 121,
	"./pocketEbook.png": 333,
	"./qiandao.png": 334,
	"./redfic.png": 335,
	"./right.png": 336,
	"./right_bg.png": 337,
	"./romancestories.png": 338,
	"./storyfm.png": 339,
	"./theme3/shu.png": 122,
	"./theme4/banner.png": 123,
	"./theme4/people.png": 124,
	"./topstories.png": 340,
	"./ty.png": 341,
	"./web-logo.png": 342,
	"./werewolfnovels.png": 343,
	"./whatsread.png": 344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;